var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.imgList.length > 0
    ? _c(
        "el-dialog",
        {
          staticClass: "show-evidence__dailog enclosure-dialog",
          attrs: {
            visible: _vm.visibleShowEnclosure,
            width: "70%",
            "modal-append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleShowEnclosure = $event
            },
            close: _vm.closeView
          }
        },
        [
          _vm.isRefresh
            ? _c(
                "el-carousel",
                {
                  attrs: {
                    height: "500px",
                    autoplay: false,
                    "indicator-position": "none",
                    arrow: _vm.imgList.length > 1 ? "always" : "never",
                    "initial-index": _vm.InitIndex
                  }
                },
                _vm._l(_vm.imgList, function(item, i) {
                  return item.file
                    ? _c(
                        "el-carousel-item",
                        {
                          key: i,
                          ref: "EnclosurePreview-" + i,
                          refInFor: true,
                          staticClass: "img-item"
                        },
                        [
                          _c("div", [
                            _c("h1", { staticClass: "h-title" }, [
                              _vm._v(_vm._s(item.file.fileName))
                            ]),
                            _c("div", { staticClass: "box-wrap" }, [
                              _vm.isVideo(item)
                                ? _c(
                                    "video",
                                    {
                                      attrs: {
                                        controls: "controls",
                                        height: "100%"
                                      }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: _vm.showFile(item.file),
                                          type: "video/mp4"
                                        }
                                      }),
                                      _c("source", {
                                        attrs: {
                                          src: _vm.showFile(item.file),
                                          type: "video/ogg"
                                        }
                                      }),
                                      _c("source", {
                                        attrs: {
                                          src: _vm.showFile(item.file),
                                          type: "video/webm"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isImg(item)
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.showFile(item.file),
                                      alt: item.file.fileName
                                    }
                                  })
                                : _vm._e()
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                }),
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b858564", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b858564","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/viewFiles/ViewFilesToImg.vue
// module id = FH4f
// module chunks = 2 3 6 8 12 13 14 17 23 24 26 27 29 31 41 42 43 47 85